module.exports = __webpack_public_path__ + "static/media/rotate_phone.1318efcd.gif";